import { createClient } from '@supabase/supabase-js';
import { ICrewData } from './ApiCalls';
import { GlobalVariables } from './GlobalVariables';

export class GlobalConstants {
    static readonly pageSize = 10;
    static readonly receiptPlaceholder = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiDQogICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIg0KICAgIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXJlY2VpcHQtZXVyby1pY29uIGx1Y2lkZS1yZWNlaXB0LWV1cm8iPg0KICAgIDxwYXRoIGQ9Ik00IDJ2MjBsMi0xIDIgMSAyLTEgMiAxIDItMSAyIDEgMi0xIDIgMVYybC0yIDEtMi0xLTIgMS0yLTEtMiAxLTItMS0yIDFaIiAvPg0KICAgIDxwYXRoIGQ9Ik04IDEyaDUiIC8+DQogICAgPHBhdGggZD0iTTE2IDkuNWE0IDQgMCAxIDAgMCA1LjIiIC8+DQo8L3N2Zz4=';

    static readonly supabase = createClient(
        process.env.REACT_APP_SUPABASE_URL as string,
        process.env.REACT_APP_SUPABASE_ANON_KEY as string
    );

    static readonly MESSAGES = {
        ERROR: {
            IMAGE: 'Valid Receipt image missing!',
            FORMS: {
                MISSING: {
                    CATEGORY: 'Valid category missing!',
                    COOWNER: 'Valid Co-owner missing!',
                    TRANSACTION: {
                        AMOUNT: 'Valid Transaction Amount missing!',
                        CURRENCY: 'Valid Transaction Currency missing!',
                        DATE: 'Valid Transaction Date missing!',
                    }
                }
            }
        }
    }

    static readonly MONTH = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];

    static readonly CreateReceiptCategories = [
        {
            label: 'Select category...',
            value: '-1',
            disabled: true,
        },
        {
            label: 'Dayworkers',
            value: '4',
        },
        // {
        //     label: 'Deck Repairs',
        //     value: '28',
        // },
        // {
        //     label: 'Interior',
        //     value: '22',
        // },
        {
            label: 'Guest transport',
            value: '46',
        },
        {
            label: 'Crew transport',
            value: '11',
        },
        {
            label: 'Marina Gratuity',
            value: '2',
        },
        {
            label: 'Restaurant  Gratuity',
            value: '44',
        },
    ];

    static readonly UserRole = {
        BASIC: 'Basic',
        STANDARD: 'User',
        ADMIN: 'Admin',
        ROOT: 'Root',
    }

    static readonly SORT = {
        compareFnCrew: (a: ICrewData, b: ICrewData) => {
            // 1. Position
            var diff = GlobalConstants.SORT.POSITIONS.indexOf(a.position) - GlobalConstants.SORT.POSITIONS.indexOf(b.position);
            if (diff !== 0) return diff;

            // 2. User Role
            diff = GlobalConstants.SORT.ROLES.indexOf(a.user_role) - GlobalConstants.SORT.ROLES.indexOf(b.user_role);
            if (diff !== 0) return diff;

            return `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`);
        },
        compareFnCrewCards: (a: ICrewData, b: ICrewData) => {
            // 1. Cards
            const aHasCard = GlobalVariables.userHasCard(a);
            const bHasCard = GlobalVariables.userHasCard(b);
            if (aHasCard !== bHasCard) return aHasCard ? -1 : 1;

            // 2. Position
            var diff = GlobalConstants.SORT.POSITIONS.indexOf(a.position) - GlobalConstants.SORT.POSITIONS.indexOf(b.position);
            if (diff !== 0) return diff;

            // 3. User Role
            diff = GlobalConstants.SORT.ROLES.indexOf(a.user_role) - GlobalConstants.SORT.ROLES.indexOf(b.user_role);
            if (diff !== 0) return diff;

            return `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`);
        },
        POSITIONS: [
            'CEO',
            'Yacht Manager',
            'Family Office Manager',
            'Product Manager',
            'Accounting',

            'Captain',

            'Chief Officer / First Mate',
            'Chief Engineer',
            'Chief Steward/Stewardess',
            'Head Chef / Executive Chef',
            'Chef/Deckhand',

            'Second Officer',
            'Third Officer',
            
            'Sous Chef',
            
            'Second Steward/Stewardess',
            'Third Steward/Stewardess',
            
            'Deckhand / Assistant Engineer',
            'Deckhand',

            'Head of Housekeeping',

            'Spa Therapist / Masseuse',

            'Bosun',
            
            'Developer',

            '',
        ],
        ROLES: [
            'Basic',
            'User',
            'Standard',
            'Admin',
            'Root',
        ],
    };
}
